import React from 'react';
import { useNavigate } from 'react-router-dom';
import './AboutUs.css';

function AboutUs() {
    const Navigate = useNavigate();

    return (
        <React.Fragment>
            <div className='container my-5'>
                <div className='about-us-title'>
                    <h1> About Us </h1>
                    <p className='about-us-info'> With our broad, technical knowledge and experience in coastal engineering, we provide services in the following areas:
                    </p>
                </div>

                <div className='services-container'>
                    <ul className='row'>
                        <div className='col-md-6'>
                            <li> Waterfront/Coastal Structures </li>
                            <li> Coastal and Estuarine Modelling </li>
                            <li> Shoreline Stabilization </li>
                            <li> Harbour and Marina Planning & Design </li>
                            <li> Sediment Sample Collection and Analysis </li>
                        </div>
                        <div className='col-md-6'>
                            <li> Dredge Disposal Assessments </li>
                            <li> Permitting </li>
                            <li> Vessel Mooring Analyses </li>
                            <li> Beach Replenishment </li>
                            <li> Coastal Hazard Assessment </li>
                        </div>
                    </ul>
                </div>

                <div className='publications-text'>
                    <p> The team at CMO Consultants has worked on some exciting stuff! Click the button to see some of the publications. </p>
                    <button className='publications-btn' onClick={() => Navigate('/publications')}> View Publications </button>
                </div>

                <div className="animation-container">
                    <iframe
                        src="https://www.youtube.com/embed/6OsMclDuhzY"
                        title="1964 Alaska Tsunami Animation -By CMO Consultants"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerPolicy="strict-origin-when-cross-origin"
                        allowFullScreen />
                </div>
            </div>
        </React.Fragment>
    )
}

export default AboutUs